import { getApplicationQuestionsByName } from "@/api/application-question.service";

export const useApplicationQuestionSearch = () => {
  const itemTitle = i => i.name;
  return {
    itemTitle,
    comparisonValue: v => v.id,
    fetchResults: async (v, searchArgs) => {
      const res = await getApplicationQuestionsByName({
        name: v,
        model: searchArgs.modelType,
        smart: searchArgs.smart,
        model_id: searchArgs.modelId
      });

      return res.toSorted((a, b) => itemTitle(a).localeCompare(itemTitle(b)));
    }
  };
};
